/**
 * judgeme-customizations.js
 * -------------------------
 * Converts Judge.me review titles from <b> to <h3> for semantic HTML and
 * accessibility compliance.
 *
 * Background:
 *   The Judge.me widget renders review titles as <b class="jdgm-rev__title">.
 *   A <b> tag carries no semantic meaning and is not picked up by screen
 *   readers or search engines as a heading. Replacing it with <h3> improves
 *   both accessibility (WCAG) and on-page SEO structure.
 *
 * How it works:
 *   1. Runs once on DOMContentLoaded to catch any titles already in the DOM.
 *   2. A MutationObserver watches for new nodes added by the Judge.me widget
 *      (which fetches reviews asynchronously) and converts titles on every
 *      update, including pagination clicks.
 *
 * Usage:
 *   Included in layout/theme.liquid via:
 *     {{ 'judgeme-customizations.js' | asset_url | script_tag }}
 */

(function () {
  /**
   * Finds every <b class="jdgm-rev__title"> in the document and replaces
   * each one with a semantically equivalent <h3> preserving class and content.
   */
  function convertTitlesToH3() {
    document.querySelectorAll('b.jdgm-rev__title').forEach(function (el) {
      var h3 = document.createElement('h3');
      h3.className = el.className;
      h3.innerHTML = el.innerHTML;
      el.parentNode.replaceChild(h3, el);
    });
  }

  /**
   * MutationObserver watches the entire document body for DOM changes.
   * This ensures titles added dynamically (async widget load, pagination)
   * are converted without needing to poll or rely on window.onload.
   */
  var observer = new MutationObserver(function () {
    convertTitlesToH3();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also run on initial load in case any titles are already present.
  document.addEventListener('DOMContentLoaded', convertTitlesToH3);
})();
